import { render, staticRenderFns } from "./modalholiday.vue?vue&type=template&id=e308ea4a"
import script from "./modalholiday.vue?vue&type=script&lang=js"
export * from "./modalholiday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports